export const InviteFriendsModalLocalStorageKey = 'hasSeenMatchInviteFriendsModal'
